import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },

  /*
  * SECTION 1.0 - Students
  */

  // 1.1 - JOB SEARCH
  {
    path: '/job-search',
    // redirect: 'personal/learn',
    component: () => import('../views/job-search.vue'),

    children: [
      // 1.1.0 - Menu
      {
        path: '',
        name: 'menu',
        component: () => import('../views/job-search/menu.vue')
      },

      // SB-03 - Map out your job search
      {
        path: '01',
        component: () => import('../views/job-search/01.vue')
      },

      // SB-04- Find out who’s hiring
      {
        path: '02',
        component: () => import('../views/job-search/02.vue')
      },

      // SB-05 - Craft your resume
      {
        path: '03',
        component: () => import('../views/job-search/03.vue')
      },

      // SB-06 - Check your resume
      {
        path: '04',
        component: () => import('../views/job-search/04.vue')
      },

      // SB-07 - Design a winning cover letter
      {
        path: '05',
        component: () => import('../views/job-search/05.vue')
      },

      // SB-08 - Make your resume and cover letter shine
      {
        path: '06',
        component: () => import('../views/job-search/06.vue')
      },

      // SB-09 - Apply for the job
      {
        path: '07',
        component: () => import('../views/job-search/07.vue')
      },

      // SB-09 - Learn from other students’ experiences
      {
        path: '08',
        component: () => import('../views/job-search/08.vue')
      }
    ]
  },

  // 1.2 - INTERVIEW PREP
  {
    path: '/interview-prep',
    // redirect: 'personal/learn',
    component: () => import('../views/interview-prep.vue'),

    children: [
      // 1.1.0 - Menu
      {
        path: '',
        name: 'menu',
        component: () => import('../views/interview-prep/menu.vue')
      },

      // SB-11 - Boost your confidence before the interview
      {
        path: '01',
        component: () => import('../views/interview-prep/01.vue')
      },

      // SB-12 - Navigate the interview with ease
      {
        path: '02',
        component: () => import('../views/interview-prep/02.vue')
      },

      // SB-13 - Interview prep for people with disabilities
      {
        path: '03',
        component: () => import('../views/interview-prep/03.vue')
      },

      // SB-14 - Reflect on the interview to learn and grow
      {
        path: '04',
        component: () => import('../views/interview-prep/04.vue')
      },

      // SB-14 - Learn from other students’ experiences
      {
        path: '05',
        component: () => import('../views/interview-prep/05.vue')
      }
    ]
  },

  // 1.3 - INTERVIEW PREP
  {
    path: '/on-the-job-success',
    // redirect: 'personal/learn',
    component: () => import('../views/on-the-job-success.vue'),

    children: [
      // 1.1.0 - Menu
      {
        path: '',
        name: 'menu',
        component: () => import('../views/on-the-job-success/menu.vue')
      },

      // SB-16 - Assess your employability skills
      {
        path: '01',
        component: () => import('../views/on-the-job-success/01.vue')
      },

      // SB-16? - Establish SMART learning goals
      {
        path: '02',
        component: () => import('../views/on-the-job-success/02.vue')
      },

      // SB-17 - Anticipate and meet employer expectations
      {
        path: '03',
        component: () => import('../views/on-the-job-success/03.vue')
      },

      // SB-17? - Make the most of your work experience
      {
        path: '04',
        component: () => import('../views/on-the-job-success/04.vue')
      },

      // SB-19 - Learn from other students’ experiences
      {
        path: '05',
        component: () => import('../views/on-the-job-success/05.vue')
      }
    ]
  },

  // 1.4 - Future Career Planning
  {
    path: '/future-career-planning',
    // redirect: 'personal/learn',
    component: () => import('../views/future-career-planning.vue'),

    children: [
      // 1.1.0 - Menu
      {
        path: '',
        name: 'menu',
        component: () => import('../views/future-career-planning/menu.vue')
      },

      // SB-19 - Reflect on your on-campus work experience
      {
        path: '01',
        component: () => import('../views/future-career-planning/01.vue')
      },

      // SB-20 - Articulate your new skills to employers
      {
        path: '02',
        component: () => import('../views/future-career-planning/02.vue')
      },

      // SB-21 - Update your resume to reflect your experience and new skills
      {
        path: '03',
        component: () => import('../views/future-career-planning/03.vue')
      },

      // SB-22 - Update your LinkedIn profile
      {
        path: '04',
        component: () => import('../views/future-career-planning/04.vue')
      },

      // SB-23 - Consider your next steps
      {
        path: '05',
        component: () => import('../views/future-career-planning/05.vue')
      },

      // SB-24 - Additional resources
      {
        path: '06',
        component: () => import('../views/future-career-planning/06.vue')
      },

      // SB-25 - Learn from other students’ experiences
      {
        path: '07',
        component: () => import('../views/future-career-planning/07.vue')
      }
    ]
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
